const locales_by_country = {
  AF: 'ps',
  AL: 'sq',
  DZ: 'ar',
  AD: 'ca',
  AO: 'pt',
  AG: 'en',
  AR: 'es',
  AM: 'hy',
  AU: 'en',
  AT: 'de',
  AZ: 'az',
  BS: 'en',
  BH: 'ar',
  BD: 'bn',
  BB: 'en',
  BY: 'be',
  BE: 'nl',
  BZ: 'en',
  BJ: 'fr',
  BT: 'dz',
  BO: 'es',
  BA: 'bs',
  BW: 'en',
  BR: 'pt',
  BN: 'ms',
  BG: 'bg',
  BF: 'fr',
  BI: 'rn',
  KH: 'km',
  CM: 'fr',
  CA: 'en',
  CV: 'pt',
  CF: 'fr',
  TD: 'fr',
  CL: 'es',
  CN: 'zh',
  CO: 'es',
  KM: 'ar',
  CG: 'fr',
  CR: 'es',
  HR: 'hr',
  CU: 'es',
  CY: 'el',
  CZ: 'cs',
  DK: 'da',
  DJ: 'fr',
  DM: 'en',
  DO: 'es',
  TL: 'pt',
  EC: 'es',
  EG: 'ar',
  SV: 'es',
  GQ: 'es',
  ER: 'ti',
  EE: 'et',
  ET: 'am',
  FJ: 'en',
  FI: 'fi',
  FR: 'fr',
  GA: 'fr',
  GM: 'en',
  GE: 'ka',
  DE: 'de',
  GH: 'en',
  GR: 'el',
  GD: 'en',
  GT: 'es',
  GN: 'fr',
  GW: 'pt',
  GY: 'en',
  HT: 'ht',
  HN: 'es',
  HU: 'hu',
  IS: 'is',
  IN: 'hi',
  ID: 'id',
  IR: 'fa',
  IQ: 'ar',
  IE: 'en',
  IL: 'he',
  IT: 'it',
  JM: 'en',
  JP: 'ja',
  JO: 'ar',
  KZ: 'kk',
  KE: 'sw',
  KI: 'en',
  KP: 'ko',
  KR: 'ko',
  KW: 'ar',
  KG: 'ky',
  LA: 'lo',
  LV: 'lv',
  LB: 'ar',
  LS: 'st',
  LR: 'en',
  LY: 'ar',
  LI: 'de',
  LT: 'lt',
  LU: 'lb',
  MK: 'mk',
  MG: 'mg',
  MW: 'ny',
  MY: 'ms',
  MV: 'dv',
  ML: 'fr',
  MT: 'mt',
  MH: 'mh',
  MR: 'ar',
  MU: 'mfe',
  MX: 'es',
  FM: 'chk',
  MD: 'ro',
  MC: 'fr',
  MN: 'mn',
  ME: 'srp',
  MA: 'ar',
  MZ: 'pt',
  MM: 'my',
  NA: 'en',
  NR: 'na',
  NP: 'ne',
  NL: 'nl',
  NZ: 'en',
  NI: 'es',
  NE: 'fr',
  NG: 'en',
  NO: 'no',
  OM: 'ar',
  PK: 'ur',
  PW: 'pau',
  PA: 'es',
  PG: 'en',
  PY: 'es',
  PE: 'es',
  PH: 'tl',
  PL: 'pl',
  PT: 'pt',
  QA: 'ar',
  RO: 'ro',
  RU: 'ru',
  RW: 'rw',
  KN: 'en',
  LC: 'en',
  VC: 'en',
  WS: 'sm',
  SM: 'it',
  ST: 'pt',
  SA: 'ar',
  SN: 'fr',
  RS: 'sr',
  SC: 'crs',
  SL: 'en',
  SG: 'en',
  SK: 'sk',
  SI: 'sl',
  SB: 'en',
  SO: 'so',
  ZA: 'zu',
  SS: 'en',
  ES: 'es',
  LK: 'si',
  SD: 'ar',
  SR: 'nl',
  SZ: 'en',
  SE: 'sv',
  CH: 'de',
  SY: 'ar',
  TJ: 'tg',
  TZ: 'sw',
  TH: 'th',
  TG: 'fr',
  TO: 'to',
  TT: 'en',
  TN: 'ar',
  TR: 'tr',
  TM: 'tk',
  TV: 'tvl',
  UG: 'sw',
  UA: 'uk',
  AE: 'ar',
  GB: 'en',
  US: 'en',
  UY: 'es',
  UZ: 'uz',
  VU: 'bi',
  VA: 'it',
  VE: 'es',
  VN: 'vi',
  YE: 'ar',
  ZM: 'en',
  ZW: 'sn',
};

export default (country_iso) => {
  if (!country_iso || !locales_by_country[country_iso]) {
    return 'en-US';
  }

  return `${locales_by_country[country_iso]}-${country_iso}`;
};
